<template lang="pug">
  .component.component-backoffice-vehicle-slot(v-if="item")
    .card(v-if="$is('listing')" )
      .inner-content
        card-n(:showBullets="true", :showAction="true", :columns="4")
          vehicle-fields(slot="n1", :item="item.vehicle", :fieldName="'vehicle-id'")
          vehicle-fields(slot="n1", :item="item.vehicle", :fieldName="'vehicle-brand-and-lot'")
          vehicle-fields(slot="n1", :item="item.vehicle", :fieldName="'vehicle-plate'")
          .cose(slot="n2" )
            .value Code: {{item.code}}
            .value Source: {{item.source}}
            .value Description: {{item.description}}
            .value Alarm at: {{item.alarm_at}}
          vehicle-status(slot="n3", :item="item.vehicle", odometer)
          div(slot="n4")
            a.fa.fa-globe.fa-2x(:href="'https://maps.google.com/?q='+item.position.latitude+','+item.position.longitude", target="_blank")
    .card(v-if="$is('map')" )
      .inner-content
        card-n(:showBullets="true", :showAction="true", :columns="4")
          vehicle-fields(slot="n1", :item="item.vehicle", :fieldName="'vehicle-id'")
          vehicle-fields(slot="n1", :item="item.vehicle", :fieldName="'vehicle-brand-and-lot'")
          vehicle-fields(slot="n2", :item="item.vehicle", :fieldName="'vehicle-plate'")
          .cose(slot="n3" )
            .value Code: {{item.code}} {{item.source}}
            .value Description: {{item.description}}

          .cose(slot="n4" )
            .value Alarm at: {{item.alarm_at}}

</template>

<script type="text/babel">
  import CardN from '../structure/CardN'
  import VehicleFields from '../structure/ui/entity-fields/VehicleFields'
  import VehicleStatus from '../structure/ui/VehicleStatus'

  export default {
    name: 'Alarm',
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
    components: {VehicleStatus, VehicleFields, CardN},
    data() {
      return {}
    },
    mounted() {
    },
    destroyed() {
    },
    updated() {

    },
    methods: {},
  }
</script>

<style lang="sass" rel="stylesheet/sass">
  .component.component-backoffice-alarm
    img
      max-width: 128px
      display: inline-block
</style>



// WEBPACK FOOTER //
// Alarm.vue?b006dbe2